import React from "react";
import { IProductTilesProps } from "../../../types/suggestion-items";
import ProductTile from "./product-tile";
import ResultButton from "./result-button";
import FlexibleSetTile from "./flexible-set-tile";

const ProductTiles = (props: IProductTilesProps) => {
    const shouldCustomerSeePrices =
        props.customerType === "Company" || props.customerType === "Surgery";

    return (
        <div className={"article-column-container " + (props.hasLeftListItems ? "padded" : "")}>
            {props.products.headline && (
                <span
                    className={`suggestions-text ${props.products.headline.type.toLowerCase()} not-selectable`}
                    key={props.products.headline?.navIndex}
                    ref={(el) => props.setRef(props.products.headline?.navIndex ?? 0, el)}
                >
                    {props.products.headline.title}
                </span>
            )}
            <div className={"article-container expanded"}>
                {props.products.articles.map((article, index) => (
                    <ProductTile
                        article={article}
                        key={article.navIndex}
                        setRef={props.setRef}
                        index={index}
                        showPrices={shouldCustomerSeePrices}
                        priceMandantSettings={props.priceMandantSettings}
                        searchInfo={props.searchInfo}
                        isPersonalized={props.isPersonalized}
                    />
                ))}
                {props.products.flexibleSets.map((set, index) => (
                    <FlexibleSetTile
                        product={set}
                        key={set.navIndex}
                        setRef={props.setRef}
                        setIndex={index}
                        articleCount={props.products.articles.length}
                        showPrices={shouldCustomerSeePrices}
                        priceMandantSettingsV2={props.priceMandantSettingsV2}
                        searchInfo={props.searchInfo}
                    />
                ))}
                {props.products.showMoreButton && (
                    <ResultButton
                        key={props.products.showMoreButton.navIndex}
                        setRef={props.setRef}
                        navIndex={props.products.showMoreButton.navIndex}
                        target={props.products.showMoreButton.target}
                        title={props.products.showMoreButton.title}
                        searchInfo={props.searchInfo}
                    />
                )}
            </div>
        </div>
    );
};

export default ProductTiles;
